import uuid from 'uuid4';

class PageView {
  uuid: string;

  constructor() {
    this.uuid = uuid();
  }

  pageViewId() {
    return this.uuid;
  }
}

export default PageView;
